<template lang="pug">
  .rake-back-skeleton-container
    SkeletonItem(className='rake-back-skeleton-title')
    SkeletonItem(className='rake-back-skeleton-banner')
    SkeletonItem(className='rake-back-skeleton-title')
    .rake-back-skeleton-list
      .rake-back-skeleton-list-item
        SkeletonItem(className='rake-back-skeleton-list-logo')
        SkeletonItem(className='rake-back-skeleton-list-text')
      .rake-back-skeleton-list-item
        SkeletonItem(className='rake-back-skeleton-list-logo')
        SkeletonItem(className='rake-back-skeleton-list-text')
      .rake-back-skeleton-list-item
        SkeletonItem(className='rake-back-skeleton-list-logo')
        SkeletonItem(className='rake-back-skeleton-list-text')
      .rake-back-skeleton-list-item
        SkeletonItem(className='rake-back-skeleton-list-logo')
        SkeletonItem(className='rake-back-skeleton-list-text')
    SkeletonItem(className='rake-back-skeleton-title')
    SkeletonItem(className='rake-back-skeleton-input')
</template>

<script>
import SkeletonItem from '@/components/skeleton-item';

export default {
  name: 'RakeBackSkeleton',
  components: {
    SkeletonItem,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.rake-back-skeleton-container {
  padding: 0.16rem 0.12rem 0.39rem;
  width: 100%;
  background-color: #fff;
  border-radius: 0.12rem;
  box-sizing: border-box;

  .rake-back-skeleton-title {
    width: 1.38rem;
    height: 0.22rem;
  }

  .rake-back-skeleton-banner {
    margin: 0.16rem 0 0.16rem;
    width: 100%;
    height: 1.1rem;
  }

  .rake-back-skeleton-list {
    display: flex;
    justify-content: space-between;
    margin: 0.16rem 0 0.24rem;
    padding: 0 0.17rem;
  }

  .rake-back-skeleton-list-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .rake-back-skeleton-list-logo {
      width: 0.48rem;
      height: 0.48rem;
    }

    .rake-back-skeleton-list-text {
      margin-top: 0.08rem;
      width: 0.48rem;
      height: 0.15rem;
    }
  }

  .rake-back-skeleton-input {
    margin: 0.16rem auto 0;
    width: 3.19rem;
    height: 0.4rem;
    border-radius: 0.24rem;
  }
}
</style>
